import ApiService from "../../api/api.service";
import { GET_EMPLOYEE_FORM, GET_PORTFOLIO_FORM, GET_ALTERNATE_FORM, SAVE_PRIVATE_INVESTMENT_DETAIL, 
	GET_PRIVATE_INVESTMENT_FORM_DETAIL, GET_EDIT_PRIVATE_INVESTMENT_FORM, UPDATE_PRIVATE_INVESTMENT_FORM,
	GET_PMS_NAME } from "../actions.type";

const getDefaultPrivateInvestmentState = () => {
	return {
		employeeForm: {},
		portfolioForm: {},
		alternateForm: {},
		savePrivateInvestment: {},
		privateInvestmentFormDetail: {},
		editPrivateInvestmentForm: {},
		updatePrivateInvestmentForm: {},
		pmsName: {},
	}
};

const state = getDefaultPrivateInvestmentState();

const getters = {

	getEmployeeForm (state) {
		return state.employeeForm;
	},
	getPortfolioForm (state) {
		return state.portfolioForm;
	},
	getAlternateForm (state) {
		return state.alternateForm;
	},
	getSavePrivateInvestment (state) {
		return state.savePrivateInvestment;
	},
	getPrivateInvestmentFormDetail (state) {
		return state.privateInvestmentFormDetail;
	},
	getEditPrivateInvestmentForm (state) {
		return state.editPrivateInvestmentForm;
	},
	getUpdatePrivateInvestmentForm (state) {
		return state.updatePrivateInvestmentForm;
	},
	getPmsName (state){
		return state.pmsName;
	}
};

const mutations = {

	setEmployeeForm (state, data) {
		state.employeeForm = data
	},
	setPortfolioForm (state, data) {
		state.portfolioForm = data
	},
	setAlternateForm (state, data) {
		state.alternateForm = data
	},
	setSavePrivateInvestment (state, data) {
		state.savePrivateInvestment = data
	},
	setPrivateInvestmentFormDetail (state, data) {
		state.privateInvestmentFormDetail = data
	},
	setEditPrivateInvestmentForm (state, data) {
		state.editPrivateInvestmentForm = data
	},
	setUpdatePrivateInvestmentForm (state, data) {
		state.updatePrivateInvestmentForm = data
	},
	setPmsName (state, data) {
		state.pmsName = data
	},
};


const actions = {

	[GET_EMPLOYEE_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setEmployeeForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_PORTFOLIO_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setPortfolioForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_ALTERNATE_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setAlternateForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[SAVE_PRIVATE_INVESTMENT_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setSavePrivateInvestment',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_PRIVATE_INVESTMENT_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setPrivateInvestmentFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_EDIT_PRIVATE_INVESTMENT_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setEditPrivateInvestmentForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[UPDATE_PRIVATE_INVESTMENT_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUpdatePrivateInvestmentForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_PMS_NAME](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setPmsName',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
};

export default {
	getters,
	actions,
	mutations,
	state
}